import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { eq, split, last, size } from 'lodash';
import { Section, SubSection } from '.';
import ChildSection from './childSection';
import { SET_CLIENT_STATE, UPDATE_PAGE_DATA, PAGE_DATA, GENERAL_SETTINGS, PAGE_LIST } from '../../../graphqls';

export default function PlanNodePageSettings() {
  const { pathname } = useLocation();
  const paths = pathname.split('/');
  const [showCurrentLatestUpdate, setShowCurrentLatestUpdate] = useState(false);
  const {
    loading: loadingPageData,
    data: { pageData = {}, pageData: { cache: { numberWithLabel, measures = [], planNodeId, children = [] } = {} } = {} } = {},
  } = useQuery(PAGE_DATA, { variables: { name: eq(paths[1], 'home') ? 'home' : paths[2] } });
  const {
    loading: loadingGeneralSettings,
    data: { generalSettings: { displayLevel, showLatestUpdate, showIndicatorOnHeader } = {} } = {},
  } = useQuery(GENERAL_SETTINGS);
  const [setState] = useMutation(SET_CLIENT_STATE);
  const [updatePageData] = useMutation(UPDATE_PAGE_DATA);

  useEffect(() => {
    const { cache = {} } = pageData;

    setShowCurrentLatestUpdate(cache.showLatestUpdate);
  }, [pageData]);

  const onAdditionalTextClick = () => setState({ variables: { modalTypeShown: 'additionalText' } });
  const onAdditionalBottomTextClick = () => setState({ variables: { modalTypeShown: 'additionalBottomText' } });
  const onAdditionalMiddleTextClick = () => setState({ variables: { modalTypeShown: 'additionalMiddleText' } });
  const onAdditionalUpperMiddleTextClick = () => setState({ variables: { modalTypeShown: 'additionalUpperMiddleText' } });
  const onLatestUpdateClick = () => setState({ variables: { modalTypeShown: 'latestUpdate' } });

  if (loadingGeneralSettings || loadingPageData) {
    return '';
  }

  let measureCards;
  let childCards;

  if (!measures.length) {
    measureCards = <div>No measures here</div>;
  } else {
    measureCards = measures.map((measure, index) => (
      <ChildSection
        isHomePage={false}
        parentPlanNodeId={planNodeId}
        updatePageData={updatePageData}
        key={`${measure.measureId}+page-settings-plannode`}
        childIndex={index}
        childData={measure}
      />
    ));
  }

  if (!children.length) {
    childCards = <div>No children here</div>;
  } else {
    childCards = children.map((child, index) => (
      <ChildSection
        isHomePage={false}
        parentPlanNodeId={planNodeId}
        updatePageData={updatePageData}
        key={`${child.planNodeId}+page-settings-plannode`}
        childIndex={index}
        childData={child}
      />
    ));
  }

  let subPlanContent = '';

  if (
    numberWithLabel &&
    { ONE: 1, TWO: 2, THREE: 3, FOUR: 4, FIVE: 5 }[displayLevel] > size(split(last(split(numberWithLabel, ' ')), '.'))
  ) {
    subPlanContent = <Section config={{ label: 'Sub Plan Content' }}>{childCards}</Section>;
  }

  const additionalTextConfig = { label: 'Additional Content' };
  const additionalBottomTextConfig = { label: 'Additional Content' };
  const additionalMiddleTextConfig = { label: 'Additional Content' };
  const additionalUpperMiddleTextConfig = { label: 'Additional Content' };
  const measuresConfig = { label: 'Measures Content' };
  const onToggle = () => {
    updatePageData({
      variables: {
        name: planNodeId,
        cache: { planNodeId, showLatestUpdate: !showCurrentLatestUpdate },
        itemId: planNodeId,
      },
      refetchQueries: [{ query: PAGE_DATA, variables: { name: planNodeId } }, { query: PAGE_LIST }],
    });

    setShowCurrentLatestUpdate(!showCurrentLatestUpdate);
  };
  const latestUpdateConfig = {
    label: 'Latest Update',
    toggle: { checked: showLatestUpdate && showCurrentLatestUpdate, onChange: onToggle, disabled: !showLatestUpdate },
  };

  return (
    <div className="page-settings-plan-node" key={['plan', 'page', 'settings', planNodeId].join('-')}>
      <Section config={additionalTextConfig}>
        <SubSection label="additionalText" customClass="plan-node-update-section" onClick={onAdditionalTextClick} />
      </Section>
      {showIndicatorOnHeader && subPlanContent}
      <Section config={latestUpdateConfig}>
        <SubSection label="latestUpdate" customClass="plan-node-update-section" onClick={onLatestUpdateClick} />
      </Section>
      <Section config={additionalUpperMiddleTextConfig}>
        <SubSection label="additionalUpperMiddleText" customClass="plan-node-update-section" onClick={onAdditionalUpperMiddleTextClick} />
      </Section>
      <Section config={measuresConfig}>{measureCards}</Section>
      <Section config={additionalMiddleTextConfig}>
        <SubSection label="additionalMiddleText" customClass="plan-node-update-section" onClick={onAdditionalMiddleTextClick} />
      </Section>
      {!showIndicatorOnHeader && subPlanContent}
      <Section config={additionalBottomTextConfig}>
        <SubSection label="additionalBottomText" customClass="plan-node-update-section" onClick={onAdditionalBottomTextClick} />
      </Section>
    </div>
  );
}
